import { useContext } from 'react';
import '../App.css';
import { ApproveBunnyDatatable } from '../components/datatables/approveBunnyDatatable';
import { AuthContext } from '../context/AuthContext';

function BunnyApproval() {
    const { auth } = useContext(AuthContext);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                    <h1 className='font-medium text-2xl'>Kaniner under ansökning</h1>
                    <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 pt-3'>
                        {auth.user?.superadmin && (
                            <>
                                {/* <Dialog open={createClubDialogOpen} onOpenChange={setCreateClubDialogOpen}>
                                    <DialogTrigger asChild>
                                        <Button className='xl:col-span-2'>
                                            <PlusCircledIcon className='mr-3' />
                                            Skapa ny förening
                                            </Button>
                                    </DialogTrigger>
                                    <CreateNewClubDialog close={setCreateClubDialogOpen} isOpen={createClubDialogOpen} onClubCreated={fetchClubs} />
                                </Dialog>
                                <Dialog open={archiveClubDialogOpen} onOpenChange={setArchiveClubDialogOpen}>
                                    <DialogTrigger asChild>
                                        <Button variant='secondary' className='xl:col-span-2'>
                                            <MinusCircledIcon className='mr-3' />
                                            Arkivera förening
                                            </Button>
                                    </DialogTrigger>
                                </Dialog> */}
                            </>
                        )}
                    </div>
                </div>
                <ApproveBunnyDatatable />
            </div>
        </div>
    );
}

export default BunnyApproval;
